import * as React from 'react';

import { OptionsViewModel } from '@models/common.models';
import { CoverageOption } from '@models/CoverageOption';

import {
  ProductViewModel,
  PriceAdjustmentViewModel,
  ProductGroupViewModel,
  ProductChannelViewModel,
  EmployeeDiscountViewModel
} from '@models/Product';
import { ProductNCoveragesComponentPropertiesAttributes, CoverageForm } from './product-n-coverages.component';
import { CoverageCalcuationComponent, CoverageCalcuationComponentProperties } from './coverage-calculation.component';
import { ViewSelectedCoveragesComponent } from './view-selected-coverages.componet';
import { PriceAdjustmentsComponent } from './price-adjustments.component';

export interface PriceAdjustmentsProperties {
  readonly productAndCoverageOptions: ProductNCoveragesComponentPropertiesAttributes;
  readonly coverageOptions: Array<CoverageOption>;
  readonly selectedCoverageOptions: Array<CoverageOption>;
  readonly calculationModel: CoverageCalcuationComponentProperties;
  readonly currentStep: number;
  readonly selectedProduct: ProductViewModel;
  readonly isOrderEdit?: boolean;
  readonly isOpenContract?: boolean;

  readonly onMount: () => void;
  readonly selectProductGroup: (productGroup: ProductGroupViewModel) => void;
  readonly selectProductChannel: (productChannel: ProductChannelViewModel) => void;
  readonly selectProduct: (product: OptionsViewModel, group: number) => void;
  readonly selectEmployeeDiscount: (employeeDiscount: EmployeeDiscountViewModel) => void;
  readonly toggleCoverageOption: (option: CoverageOption) => void;
  readonly selectPriceAdjustment: (adjustment: PriceAdjustmentViewModel) => void;
  readonly toggleSellersCoverage: () => void;
  readonly setPriceAdjustmentAmount: (amount: number) => void;
  readonly onSaveClick: (model: CoverageForm) => void;
  readonly onLeave: () => void;
}

export class PriceAdjustmentsPage extends React.Component<PriceAdjustmentsProperties> {
  constructor(props: PriceAdjustmentsProperties) {
    super(props);
  }

  componentDidMount() {
    this.props.onMount();
  }

  componentWillUnmount() {
    this.props.onLeave();
  }

  render() {
    return (
      <div className="form-horizontal">
        <div className="row">
          <div className="col-md-12">
            <h2>Step {(this.props.currentStep + 1).toString()}: Price Adjustments</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-3 col-lg-4">
            <PriceAdjustmentsComponent
              {...this.props.productAndCoverageOptions}
              selectEmployeeDiscount={this.props.selectEmployeeDiscount}
              onSaveClick={this.props.onSaveClick}
              setPriceAdjustmentAmount={this.props.setPriceAdjustmentAmount}
              selectPriceAdjustment={this.props.selectPriceAdjustment}
              isOrderEdit={this.props.isOrderEdit}
              isOpenContract={this.props.isOpenContract}
            />
          </div>

          <div className="col-xs-12 col-md-9 col-lg-8">
            <ViewSelectedCoveragesComponent
              product={this.props.selectedProduct}
              coverageOptions={this.props.selectedCoverageOptions}
              hasSellersCoverage={true}
            />
            <CoverageCalcuationComponent {...this.props.calculationModel} />
          </div>
        </div>
        <div className="row end-xs">
          <div className="col-md">
            <button hidden={true} className="btn btn-primary" type="submit">
              Continue
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/coverage/_components/price-adjustments-page.component.tsx